import { Injectable } from '@angular/core';

@Injectable()
export class WindowRefService {
  replaceHash: Function;

  cookieJSONToString(cookies: object, skip: Array<string> = []): string {
    if (!Object.keys(cookies).length) return '';
    return `${Object.keys(cookies)
      .filter((key: string): boolean => !skip.includes(key))
      .map((key: string): string => `${key}=${cookies[key]}`).join(';')};`;
  }

  getWindow(): any {
    return window;
  }

  get nativeWindow(): any {
    return this.getWindow();
  }

  /** True when embedded in an iframe (the doctor dashboard); native app and browser tab are top-level. */
  isRenderedInIframe(): boolean {
    const win = this.nativeWindow;
    if (!win) return false;
    try {
      return win.self !== win.top;
    } catch {
      // A SecurityError can only be raised when a cross-origin ancestor exists, which means we are framed.
      return true;
    }
  }

  isMobileBrowser(): boolean {
    if (this.nativeWindow.navigator.userAgent.match(/Android/i)
      || this.nativeWindow.navigator.userAgent.match(/webOS/i)
      || this.nativeWindow.navigator.userAgent.match(/iPhone/i)
      || this.nativeWindow.navigator.userAgent.match(/iPad/i)
      || this.nativeWindow.navigator.userAgent.match(/iPod/i)
      || this.nativeWindow.navigator.userAgent.match(/BlackBerry/i)
      || this.nativeWindow.navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    }
    return false;
  }

  isSafariBrowser(): boolean {
    if (this.nativeWindow.navigator.vendor.toLowerCase().match(/apple/i)
      || this.nativeWindow.navigator.userAgent.match(/iPhone/i)
      || this.nativeWindow.navigator.userAgent.match(/iPad/i)
      || this.nativeWindow.navigator.userAgent.match(/iPod/i)
    ) {
      return true;
    }
    return false;
  }

  getUserAgent(): string {
    return this.nativeWindow.navigator.userAgent;
  }
}
